export default __webpack_public_path__ + "static/media/buttons5.01ae7d02.jpg";